import React, {FC, useState} from 'react';

import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select, {SelectChangeEvent} from '@mui/material/Select';

import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import {Crop, Municipality, Use} from '@/domain/services/Clas';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import UndoIcon from '@mui/icons-material/Undo';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export interface Props {
  items: Array<Crop> | Array<Use> | Array<Municipality>,
  selectedUuid?: string,
  onChange: (uuid: string | undefined) => void
}

const UuidSelect: FC<Props> = ({
  items,
  selectedUuid,
  onChange,
}) => {

  const [isEditing, setEditing] = useState(false);

  const handleEdit = () => setEditing(!isEditing);

  const handleChange = (e: SelectChangeEvent) => {
    onChange(e.target.value);
    handleEdit();
  };

  return <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', m: 0, p: 0}}>
    {
      isEditing ?
        <FormControl fullWidth sx={{minWidth: 100}}>
          <Select size="small" value={selectedUuid ?? ''} onChange={handleChange} sx={textFieldEditableSx}>
            {
              items.map((item, index) => <MenuItem
                sx={{fontSize: '0.875rem', py: 0, fontWeight: 900}}
                key={index} value={item.uuid}>
                {item.name}
              </MenuItem>)
            }
          </Select>
        </FormControl>
        : <FormControl
          sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', borderRadius: '4px', minWidth: 100}}
          fullWidth>
          {
            selectedUuid ?
              <Select size="small" value={selectedUuid} sx={textFieldNoEditableSx} readOnly
                IconComponent={() => <ArrowDropDown style={{display: 'none'}}/>}
              >
                {
                  items.map(item => <MenuItem key={item.uuid} value={item.uuid}>{item.name}</MenuItem>)
                }
              </Select>
              : <Typography sx={{fontSize: '0.875rem', fontWeight: 900, color: 'grey.7000', marginLeft: 2}}>-</Typography>
          }
        </FormControl>
    }
    {
      isEditing 
        ? <IconButton aria-label="reset" size='small' onClick={handleEdit}>
          <UndoIcon sx={{color: 'grey.700'}}/>
        </IconButton>
        : <IconButton aria-label="edit" size='small' onClick={handleEdit}>
          <ModeEditIcon sx={{color: 'grey.700'}}/>
        </IconButton>
    }
  </Box>;
};

export default UuidSelect;

const textFieldNoEditableSx = {
  borderRadius: '4px',
  border: '0px solid red',
  flexGrow: 1,
  fontSize: '0.875rem',
  fontWeight: 900,
  '& .MuiInputBase-input': {
    borderRadius: '4px',
    fontSize: '0.875rem'
  },
  '.MuiSelect-select': {
    color: 'grey.700'
  },
  '.MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },
  maxWidth: '310px',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

const textFieldEditableSx = {
  borderRadius: '4px',
  flex: 1,
  fontSize: '0.875rem',
  '& .MuiInputBase-input': {
    fontSize: '0.875rem'
  }
};